import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var rgb2num = function rgb2num() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _slicedToArray(_unpack, 3),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2];
  return (r << 16) + (g << 8) + b;
};
export default rgb2num;